import { getCurriculum } from 'a/allAboard/content/curriculum';
import { MASTERY_THRESHOLD } from 'a/allAboard/data/constants';

const getQuestionSet = (levelIndex, contentSideIndex) => getCurriculum().levels[levelIndex].rounds[contentSideIndex];

const getQuestion = (state) => {
  const {
    allAboardReducer: {
      roundPlay: {
        currentLevelIndex, currentQuestionIndex,
      },
    },
  } = state;
  const contentSideIndex = getContentSideIndex(state);
  return getQuestionSet(currentLevelIndex, contentSideIndex).questions[currentQuestionIndex];
};

export const getLevelCount = () => getCurriculum().levels.length;

export const getCorrectResponse = state =>
  getQuestion(state).target;

export const getQuestionWord = state =>
  getQuestion(state).word;

export const getQuestionId = state => getQuestion(state).questionId;

export const getQuestionUuid = state => getQuestion(state).uuid;

export const getContentSideIndex = (state) => {
  const {
    allAboardReducer: {
      roundPlay: {
        currentLevelIndex,
      },
    },
  } = state;
  return getContentSideFlagsByLevel(state)[currentLevelIndex];
};

export const getContentSideId = (state) => {
  const id = getContentSideIndex(state) === 0 ? 'A' : 'B';
  return id;
};

export const getContentSideFlagsByLevel = state =>
  state.allAboardReducer.gameDetails.contentSideFlagsByLevel;

/**
 * Derived round mastery: the share of first-try-correct questions vs the mastery threshold.
 * Pure function of the round's outcomes (replaces a stored achievedMastery flag). Empty outcomes →
 * false. Meaningful at the end of the round; the results screen keys off roundState, not this value,
 * to know when the round has ended.
 */
export const getDidAchieveMastery = (state) => {
  const { itemResponseOutcomesAllQ } = state.allAboardReducer.roundPlay;
  const questionsTried = itemResponseOutcomesAllQ.length;
  if (!questionsTried) {
    return false;
  }
  const correct = itemResponseOutcomesAllQ.filter(Boolean).length;
  return (correct * 100) / questionsTried >= MASTERY_THRESHOLD;
};

// Find which cells should be active. Is used for determining which buttons to render (and in what order --- For accessibility reasons)
// The result includes the currently selected cells and any next square(s) in front of it. If there are no selected squares, it includes the next square(s) in front of the engine
export const getActiveCells = (state) => {
  const {
    allAboardReducer:
    {
      maze: {
        currentTrain: train,
        studentSelection: selection,
        currentMaze: maze,
      },
    },
  } = state;
  if (train.length && maze.length && maze[maze.length - 1].length) {
    const head = selection.length ? selection[selection.length - 1] : train[train.length - 1];
    const headMazeSquare = maze[head.y][head.x];
    const headNextSquares = headMazeSquare.nextSquares;
    const copyHeadNextSquares = headNextSquares.map(cell => ({ selected: false, ...cell }));
    const selectedCells = selection.map(cell => ({ selected: true, ...cell }));

    const activeCells = [...selectedCells, ...copyHeadNextSquares];
    return activeCells;
  }
  return [];
};
